import { render, staticRenderFns } from "./BConfirm.vue?vue&type=template&id=0a26086e"
import script from "./BConfirm.vue?vue&type=script&lang=js"
export * from "./BConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports